import { apiClient } from '@/services/ApiClient.js'

export class AchievementService {
  static getAchievements(goalId) {
    return apiClient
      .get('goals/' + goalId + '/achievements')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getAchievement(goalId, achievementId) {
    return apiClient
      .get('goals/' + goalId + '/achievements/' + achievementId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createAchievement(goalId, achievement) {
    return apiClient
      .post('goals/' + goalId + '/achievements', achievement)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updateAchievement(goalId, achievementId, achievement) {
    return apiClient
      .patch('goals/' + goalId + '/achievements/' + achievementId, achievement)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deleteAchievement(goalId, achievementId) {
    return apiClient
      .delete('goals/' + goalId + '/achievements/' + achievementId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
